module.exports = __webpack_public_path__ + "img/Congrats.5ac13bd5.gif";